import React from 'react';
import { useTranslation } from 'react-i18next';
import Tip from '../Tip/Tip';

const TipStakeholderFinancialDriver = () => {
  const { t } = useTranslation();
  return (
    <Tip>
      <p>
        {t('tipStakeholderFinancialDriver')}
      </p>
    </Tip>
  );
};

export default TipStakeholderFinancialDriver;
